/**
 * Writes a text string to the system clipboard.
 *
 * @async
 * @param {string} text text to be written to the clipboard
 * @throws {Error} unable to copy text to clipboard
 */
export const copyTextToClipboard = async text => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    throw new Error(`Unable to copy text to clipboard: ${error.message}`);
  }
};

// Cópia com plano B pra contexto sem Clipboard API (webview, http, iframe sem
// `clipboard-write`): textarea + execCommand. Diferente do copyTextToClipboard
// acima, que só tem o caminho moderno. Falha nos dois caminhos LEVANTA — quem
// chama (useCopyFeedback) mostra o erro no botão. Usado pelo useCopyFeedback
// (botões de copiar do webchat e card de cobrança do widget do Site).
export const copyText = async text => {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const field = document.createElement('textarea');
  field.value = text;
  field.setAttribute('readonly', '');
  field.style.cssText = 'position:fixed;left:-9999px;top:0';
  document.body.append(field);
  field.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } finally {
    field.remove();
  }
  if (!ok) throw new Error('copy_failed');
};
